export enum SelectEnum {
    firstOption = 1,
    secondOption = 2,
    thirdOption = 3,
    fourthOption = 4,
    fifthOption = 35,
    sixthOption = 37
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/selection.enum.ts